import { Pencil } from 'lucide-react';
import React from 'react';
import { IconButton, FormDrawer } from '../../ui';
import FormEntiteUpdate from '../Forms/FormEntiteUpdate';

export default function UpdateEntite(props: { handleFunction: any, entite: any }) {
    const [open, setOpen] = React.useState(false);

    return (
        <div>
            <IconButton size={32} color="warning" tooltip="Modifier cette entité" onClick={() => setOpen(true)}>
                <Pencil size={16} />
            </IconButton>
            <FormDrawer
                open={open}
                onClose={() => setOpen(false)}
                title={`Modification de l'entité`}
                hint="Les informations existantes sont pré-remplies. Modifiez les champs souhaités puis enregistrez."
            >
                <FormEntiteUpdate handleFunction={() => { setOpen(false); props.handleFunction() }} entite={props.entite} />
            </FormDrawer>
        </div>
    );
}
